<script>
import B0601Index from '../B0601/index.vue'
export default {
  data() {
    return {
      title: '配送パターン再確認'
      // saveRules: this.savable
    }
  },
  mixins: [B0601Index],
  methods: {
    returnToList() {
      this.$message('', '保存済')
      this.$router.push('/B0800')
    },
    getConfigStatus() {
      return { status: 'DO業者確認済' }
    },
    getPatternSearchShow() {
      return false
    },
    back() {
      this.$router.push('/B0800')
    }
  },
  computed: {
    for800() {
      return true
    },
    for600() {
      return false
    },
    savable() {
      return (
        this.valid &&
        this.routingValid &&
        this.hasPattern &&
        (this.detail.status === '受入確認済' ||
          this.detail.status === 'DO諸掛登録済' ||
          this.detail.status === '納入指示済' ||
          this.detail.status === 'DO業者確認済' ||
          this.detail.status === 'DO解除済' ||
          this.detail.actStatus === '受入確認済' ||
          this.detail.actStatus === 'DO諸掛登録済' ||
          this.detail.actStatus === '納入指示済' ||
          this.detail.actStatus === 'DO業者確認済' ||
          this.detail.actStatus === 'DO解除済')
      )
    },
    hasPattern() {
      //第一段线路的终点不为空
      return (
        this.detail &&
        this.detail.routes &&
        this.detail.routes[0].destinationWarehouseId != null
      )
    }
  }
}
</script>